import { PropsWithChildren } from "react";
import { FrigadeProvider } from "@frigade/react";
import { defaultAppHost } from "../api/api";
import { config, developmentPublicApiKey, productionPublicApiKey } from "../settings/frigade";
import { useSessionContext } from "supertokens-auth-react/recipe/session";

export default function FrigadeProviderWrapper({ children }: PropsWithChildren<{}>) {
  const sessionContext = useSessionContext() as any;
  const { userId } = sessionContext;
  const isProduction = window.location.hostname === defaultAppHost;
  const apiKey = isProduction ? productionPublicApiKey : developmentPublicApiKey;

  if (!userId || !apiKey) {
    return children;
  }

  return (
    <FrigadeProvider publicApiKey={apiKey} userId={userId} config={config}>
      {children}
    </FrigadeProvider>
  );
}
